import { render, staticRenderFns } from "./future.vue?vue&type=template&id=7e1fa4fe&scoped=true&"
import script from "./future.vue?vue&type=script&lang=js&"
export * from "./future.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./future.vue?vue&type=style&index=1&id=7e1fa4fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1fa4fe",
  null
  
)

export default component.exports